export default "__VITE_ASSET__B2Hq_$tc__"